module.exports = __webpack_public_path__ + "img/dots.90bfeffd.svg";